import { Component, Input, OnInit, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
} from "@angular/forms";
import { AppStateService } from "src/app/core-module/services/app-state.service";
import { FieldType } from "@ngx-formly/core";
import { Subscription } from "rxjs";
import { FeatureDataStateService } from "../../../core-module/services/state/feature-data-state.service";
import { FeatureDefaultsStateService } from "../../../core-module/services/state/feature-defaults-state.service";
import { FeatureUtilsService } from "../../../core-module/services/state/feature-utils.service";
export const CustomPasswordValidator = (form: FormGroup, checkprop: string) => {
  return (ctrl: FormControl) => {
    const checkControl = form.get(checkprop);
    const props = ["p1", "p2", "p3", "p4", "vp1", "vp2", "vp3", "vp4"];
    const hasError = ctrl.value != checkControl.value
      || !ctrl.value
      || !(Number(ctrl.value) >=0 && Number(ctrl.value) <= 255)
      || props.every(prop => form.get(prop).value == "0")
      || props.every(prop => form.get(prop).value == "255")

    if (hasError) return { error: true };
    return null;
  };
};
@Component({
  standalone: false,
  selector: "app-owp",
  templateUrl: "./owp.component.html",
  styleUrls: ["./owp.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OwpComponent extends FieldType implements OnInit {
  isSelectAll: boolean;
  @Input() field;

  maskWebNames: LegacyAny = {
    DALI102ADDRESSING: "DALI 102 Addressing",
    ALO: "ALO",
    ALOMIN: "ALO Min",
    FLEXTUNE: "FlexTune",
    AOC: "AOC",
    CLO: "CLO",
    CLOLITE: "CLOLite",
    CORRIDORMODE: "Corridor Mode",
    CORRIDOR: "Corridor",
    TOUCHDIM: "Touch and Dim",
    DTL: "DTL",
    DYNADIMMER: "Dynadimmer",
    LINESWITCH: "Line Switch",
    TOUCHANDDIM: "Touch and Dim",
    DIMMINGINTERFACE: "Dimming Interface",
    LUMINAIREINFO: "Luminaire Info",
    LUMINFOFORMAT3: "Luminaire Info",
    LUMINFOFORMAT: "Luminaire Info",
    OWP: "OWP",
    DALIPSU: "DALI PSU",
    DCEMERGENCY: "DC Emergency",
    ZTV: "ZTV",
    CODEDMAINS: "Coded Mains",
    MINDIMLEVEL: "Min Dim Level",
    MTP: "MTP",
    AST: "AST",
    AMPDIM: "Amp Dim",
    AUXOUTPUTVOLTAGE: "Aux Output Voltage",
    STEPDIMMING: "Step Dimming",
    LSI: "LSI",
    OTP: "OTP",
    DSC: "DSC",
    LOWMAINSLOCK: "Low Mains Lock",
    DIPSWITCH: "DIPSwitch",
    LSA: "LSA",
    CODEDLIGHT: "Coded Light",
    EOL:"EOL",
    AOCDUALCHANNEL: "AOC Dual Channel",
    AOCMULTICHANNEL: "AOC Multi Channel",
    CLODUALCHANNEL: "CLO Dual Channel",
    CLOMULTICHANNEL: "CLO Multi Channel",
    CCTMULTICHANNEL: "CCT Multi Channel",
    DYNADIMMERDUALCHANNEL: "Dynadimmer Dual Channel",
    DYNADIMMERMULTICHANNEL: "Dynadimmer Multi Channel",
  };

  pathVal;
  selectedFeatures: LegacyAny = {};
  owpAvailableFeatures = [];
  owpProperties = {};
  owpPasswordForm = new FormGroup({});
  valueChangesSub: {[key: string]:Subscription}= {};
  showNewPasswords: boolean = false;
  showVerifyPasswords: boolean = false;

  constructor(

    private fb: FormBuilder,
    private ref: ChangeDetectorRef,
    private appState: AppStateService,
    private utils: FeatureUtilsService,
    private featureDefaults: FeatureDefaultsStateService,
    private featureData: FeatureDataStateService
  ) {
    super();
  }

  ngOnInit() {
    this.pathVal = this.utils.getImageUrl(window.location.hostname);
    this.featureDefaults.getowpRestoreDefaultValue.subscribe((response) => {
      if (response) {
        this.restoreDefault();
      }
    });

    if (this.field) {
      this.owpProperties = this.field.properties;
      this.buildInitialData();
    }
  }

  buildInitialData() {
    const localData = this.getValueFromLocal();
    if(localData && localData["OwpEnabled"]) localData["OwpEnabled"] = localData["OwpEnabled"].map(feat => feat.toUpperCase().trim())
    this.owpProperties["OwpEnabled"].featureSet.forEach((feature: string) => {
      const name = feature.toUpperCase().trim();
      if (name !== "SRPSU") {
        this.owpAvailableFeatures.push(name);
        this.selectedFeatures[name] =
          localData && localData["OwpEnabled"]
            ? localData["OwpEnabled"].includes(name)
            : false;
      }
    });
    const keys_relations = {"p1":"vp1", "p2":"vp2", "p3":"vp3", "p4":"vp4", "vp1":"p1", "vp2":"p2", "vp3":"p3", "vp4":"p4"};
    for (const item in keys_relations) {
      const control = new FormControl(null);
      this.owpPasswordForm.addControl(item, control);
      this.syncFormChanges(item);
    }
    for (const name in this.owpPasswordForm.controls) {
      this.owpPasswordForm
        .get(name)
        .setValidators(CustomPasswordValidator(this.owpPasswordForm, keys_relations[name]));
    }
    const passwordValue={};
    if(localData){
      for(let i=0; i<4; i++){
        passwordValue['p'+(i+1)] = localData['OwpPassword'] && localData['OwpPassword'][i] ? localData['OwpPassword'][i] : null;
        passwordValue['vp'+(i+1)] = localData['OwpVerifyPassword'] && localData['OwpVerifyPassword'][i] ? localData['OwpVerifyPassword'][i] : null
      }
      this.owpPasswordForm.patchValue({...passwordValue}, {emitEvent: false});
    }
    this.checkForSelectAll();
    this.checkForPasswordEnable();
    this.saveValueOnChange();
  }

  restoreDefault(){
    this.owpAvailableFeatures.forEach(feat => {
      this.selectedFeatures[feat] = false;
    })
    this.isSelectAll = false;
    this.checkForPasswordEnable();
    this.saveValueOnChange();
    this.ref.markForCheck();
  }

  syncFormChanges(item) {
    const control = this.owpPasswordForm.get(item);
    this.valueChangesSub[item] = control.valueChanges.subscribe((res) => {
      for (const key in this.owpPasswordForm.controls) {
        this.updateonlyValidity(key);
      }
      this.saveValueOnChange();
    });
  }

  onCheckboxChange(item) {
    this.checkForSelectAll();
    this.checkForPasswordEnable();
    this.saveValueOnChange();
  }

  selectAll(value) {
    this.isSelectAll = value;
    this.owpAvailableFeatures.forEach((feat) => {
      this.selectedFeatures[feat] = value;
    });
    this.checkForPasswordEnable();
    this.saveValueOnChange();
  }

  checkForSelectAll() {
    this.isSelectAll = this.owpAvailableFeatures.every(
      (feat) => this.selectedFeatures[feat]
    );
  }

  checkForPasswordEnable() {
    const enable = this.owpAvailableFeatures.some(
      (feat) => this.selectedFeatures[feat]
    );
    for (const key in this.owpPasswordForm.controls) {
      const control = this.owpPasswordForm.get(key);
      if (enable) control.enable({ emitEvent: false });
      else {
        control.patchValue(null, { emitEvent: false });
        control.disable({ emitEvent: false });
      }
      this.updateonlyValidity(key);
    }
  }

  getRoundOff(number) {
    return Math.round(number);
  }

  updateonlyValidity(controlName) {
    const control = this.owpPasswordForm.get(controlName);
    if (this.valueChangesSub[controlName]) {
      this.valueChangesSub[controlName].unsubscribe();
      delete this.valueChangesSub[controlName];
      control.updateValueAndValidity();
      this.syncFormChanges(controlName);
    } else {
      control.updateValueAndValidity();
    }
  }

  saveValueOnChange(){
    this.featureDefaults.setowpDefaultColor(this.checkForDefault());
    this.sendOwpData();
    this.featureData.owpInputError(!this.checkForDefault() && this.owpPasswordForm.invalid);
  }

  checkForDefault(){
    return !this.owpAvailableFeatures.some(feat => this.selectedFeatures[feat])
  }

  sendOwpData(){
    const value = {};
    value['OwpPassword'] = [];
    value['OwpVerifyPassword'] = [];
    value['OwpEnabled'] = this.owpAvailableFeatures.filter(feat => this.selectedFeatures[feat]);
    if(value['OwpEnabled'].length > 0){
      for(const key of ['p1', 'p2', 'p3', 'p4']){
        value['OwpPassword'].push(this.owpPasswordForm.get(key).value);
      }
      for(const key of ['vp1', 'vp2', 'vp3', 'vp4']){
        value['OwpVerifyPassword'].push(this.owpPasswordForm.get(key).value)
      }
    }
    this.setValueInLocal(value);
    this.featureData.sendowpdata({
      OwpEnabled : value['OwpEnabled'],
      OwpPassword: value['OwpPassword'].map(val => val ? Number(val):val)
    });
  }

  getValueFromLocal() {
    // Use centralized method to get feature data
    // This automatically prioritizes SaveSetData over ConfigurationData
    return this.appState.getFeatureData('OWP');
  }

  setValueInLocal(value){
    // Use centralized method to save feature data
    // This automatically saves to both ConfigurationData and SaveSetData
    this.appState.setFeatureData('OWP', value);
  }

  toggleShowNewPasswords() {
    this.showNewPasswords = !this.showNewPasswords;
  }

  toggleShowVerifyPasswords() {
    this.showVerifyPasswords = !this.showVerifyPasswords;
  }

  onAutoAdvance(currentControlName: string, nextInput: HTMLInputElement | null) {
    const control = this.owpPasswordForm.get(currentControlName);
    if (!control) { return; }
    const val: string = control.value;
    // If user pasted, trim to 3 chars
    if (val && val.length > 3) {
      control.setValue(val.substring(0, 3));
    }
    if (val && val.length === 3) {
      const num = parseInt(val, 10);
      // Auto-advance for LegacyAny valid value 0-255 (including 000 and 255)
      if (!isNaN(num) && num >= 0 && num <= 255) {
        if (nextInput) {
          nextInput.focus();
          nextInput.select();
        }
      }
    }
  }

  onBackspaceNavigate(event: KeyboardEvent, prevInput: HTMLInputElement | null, currentControlName: string) {
    if (event.key === 'Backspace') {
      const control = this.owpPasswordForm.get(currentControlName);
      if (control && (!control.value || control.value.length === 0)) {
        if (prevInput) {
          event.preventDefault();
          prevInput.focus();
          prevInput.select();
        }
      }
    }
  }

}
